import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import styles from './RetailersMenu.module.scss';
import RoleContainer from '../../../containers/blocks/RoleContainer';
import UserMenuContainer from '../../../containers/menus/UserMenuContainer';
import useScroll from '../../../hooks/useScroll';
import logo from '../../../images/cymbio-logo-only.svg';
import { TAB_DROPSHIP, TAB_REORDER } from '../../../constants/mainConstants';

function RetailersMenu(props) {
  const { retailerId, pathname } = props;

  let [sticky, setSticky] = useState(false);

  useScroll(
    ({ prevPos, currPos }) => {
      if (currPos.y > -56) {
        setSticky(false);
      } else if (currPos.y < prevPos.y) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    },
    null,
    { wait: 50 },
  );

  const createMenu = () => {
    const menu = {};

    if (props.dropship) {
      menu.dropship = `/retailers/${retailerId}/dropship`;
    }

    if (props.replenish) {
      menu.reorder = `/retailers/${retailerId}/reorder`;
    }

    return menu;
  };

  const menuItems = () => {
    const menu = createMenu();

    const items = Object.keys(menu).map((key) => {
      const value = menu[key];
      const active = pathname.includes(value);

      return (
        <li key={key}>
          <Link className={active ? styles.active : ''} to={value}>
            {key}
          </Link>
        </li>
      );
    });

    return <ul className={styles.menuItems}>{items}</ul>;
  };

  const menuIcons = () => {
    const { dropship, replenish, administration, cartVariantsCount } = props;

    const isReplenish = pathname.includes(TAB_REORDER);
    const isDropship = pathname.includes(TAB_DROPSHIP);

    return (
      <div className={cn(styles.panel_icons, 'menu_wrapper')}>
        {isReplenish && replenish && cartVariantsCount > 0 && (
          <Link to={`/retailers/${retailerId}/reorder/cart`}>
            <div className={styles.cartCountWrapper}>
              <span className="ic-shopping_cart" title="Cart" />
              <span className={styles.cartCount}>{cartVariantsCount}</span>
            </div>
          </Link>
        )}

        {dropship && isDropship && (
          <Link to={`/retailers/${retailerId}/dropship/orders`}>
            <span className="ic-list" title="Orders" />
          </Link>
        )}

        {replenish && isReplenish && (
          <Link to={`/retailers/${retailerId}/reorder/orders`}>
            <span className="ic-list" title="Orders" />
          </Link>
        )}

        {administration && (
          <Link to={`/retailers/${retailerId}/admin`}>
            <span className="ic-settings" title="Admin" />
          </Link>
        )}

        <RoleContainer />

        <UserMenuContainer />
      </div>
    );
  };

  return (
    <div className={cn(styles.wrapper_static, sticky ? styles.sticky : '')}>
      <header className={styles['header-retailer']}>
        <div className={styles.logo}>
          <Link to="/">
            <img alt="Cymbio Logo" src={logo} />
            <span>{props.retailerName}</span>
          </Link>
        </div>

        <nav>{menuItems()}</nav>

        <div className={styles.panel}>{menuIcons()}</div>
      </header>
    </div>
  );
}

export default RetailersMenu;

RetailersMenu.defaultProps = {
  retailerName: '',
  administration: false,
  cartVariantsCount: 0,
};

RetailersMenu.propTypes = {
  pathname: PropTypes.string.isRequired,
  retailerId: PropTypes.number,
  retailerName: PropTypes.string,
  administration: PropTypes.bool,
  dropship: PropTypes.bool.isRequired,
  replenish: PropTypes.bool.isRequired,
  cartVariantsCount: PropTypes.number,
};
